import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

const fadeOutPastDates = (date) => {
  const isToday = date.toDateString() === new Date().toDateString();
  const isFutureDate = date > new Date();
  const dateClass = isToday || isFutureDate ? '' : 'ui-datepicker-past-date';

  return [true, dateClass];
};

// jQuery UI binds the document listener that closes an open datepicker on an outside click once,
// when the first datepicker is created. Create one here, outside any onPageLoad run, so onPageLoad
// never takes that listener for page setup and removes it after a Turbo visit.
$('<input>').datepicker().datepicker('destroy');

// jQuery UI datepicker options: the team's date format and faded past dates. Every file that
// creates a datepicker imports this module, so the defaults are in place first.
onPageLoad(() => {
  $.datepicker.setDefaults({
    dateFormat: $('meta[name=date-format]').attr('content'),
    beforeShowDay: fadeOutPastDates,
  });
});
